import { HttpService } from '@/infra/http'

type TSimulacaoPropostaStatus = 'Gerada' | 'Enviada'
type TSimulacaoProdutoStatusProposta = 'Disponivel' | 'Reservada'
type TSimulacaoTipoProdutoProposta = 'Unidade' | 'Acessorio'

type TSimulacaoPropostaRelacionada = {
  id: string
  tipoDoProduto: TSimulacaoTipoProdutoProposta
  status: TSimulacaoPropostaStatus
  nomeEmpreendimento: string
  nomeBloco: string
  possuiParcelaVencida: boolean
  produto: {
    idExterno: number
    codigo: string
    status: TSimulacaoProdutoStatusProposta
  }
  valorTotalSimulado: number
  diaMes: string
  quantidadeDias: number
}

export type TGetSimulacoesRelacionadas = {
  simulacaoPrincipal: TSimulacaoPropostaRelacionada
  relacionadas: TSimulacaoPropostaRelacionada[]
}

export class GetSimulacoesRelacionadas extends HttpService {
  execute = async (simulacaoId: string) => {
    return this.http.get<TGetSimulacoesRelacionadas>(`/api/v2/Simulacao/${simulacaoId}/relacionadas`)
  }
}
